/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {FindMerchantsRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {FindMerchantsResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const findMerchants = (request: FindMerchantsRequest, options?: CashRequestOptions) => post<FindMerchantsRequest, FindMerchantsResponse>("/2.0/cash/find-merchants", request, {...options, rejectOnError: true })